import styled from '@emotion/styled'
import Button from '@/components/generics/Button'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  @media (max-width: 768px) {
    height: auto;
  }
`

export const Content = styled.div`
  max-width: 450px;
  padding: 0 15px 15px;
`
export const Image = styled.img`
  display: block;
  width: 100%;
  max-width: 350px;
  margin: 0 auto 24px;
`

export const Title = styled.h1(
  ({ theme }) => `
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  line-height: 1.1;
  color: ${theme.ds.ColorBaseGreyLevel4};
`
)

export const Subtitle = styled.h2(
  ({ theme }) => `
  font-size: 16px;
  text-align: center;
  line-height: 1.1;
  font-weight: normal;
  margin: 24px 0;
  color: ${theme.ds.ColorBaseGreyLevel4};
`
)

export const CustomButton = styled(Button)`
  width: 100%;
  max-width: 285px;
  margin: 0 auto;
  display: block;
`
